import _regeneratorRuntime from "D:\\agent\\_work\\100\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _slicedToArray from "D:\\agent\\_work\\100\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useState, useEffect, useContext, useCallback } from "react";
import createAuth0Client from "@auth0/auth0-spa-js";
import config from "../dal/config";
import { CustomerStatus, OrderPhysician, RoleType } from "../dal/models";
import physicians from "../dal/physicians";
import institutionsApi from "../dal/institutions";
import { postLog } from "../dal/logging";
import { LogLevel } from "../dal/enums";
import { GetStoredInstitutionCodes } from "../utils/PhysicianHelper";
import { isNil } from "lodash";
import { ALL_PERMISSIONS } from "../constants/permissions";
import { ALL_ROLES } from "../constants/roles";
export var UserState;
(function (UserState) {
  UserState["NotLoggedIn"] = "NotLoggedIn";
  UserState["Loading"] = "Loading";
  UserState["NeedRegistration"] = "Need Registration";
  UserState["WaitingForApproval"] = "Waiting For Approval";
  UserState["Ok"] = "Ok";
  UserState["Error"] = "Error";
})(UserState || (UserState = {}));
var defaultAuth0Context = {
  isAuthenticated: false,
  loading: false,
  setPhysician: function setPhysician() {},
  userState: UserState.Loading,
  institutions: [],
  setSelectedInstitution: function setSelectedInstitution() {},
  emailVerified: false,
  isAdmin: false,
  siteRoles: [],
  isVA: false,
  allRoles: [],
  allPermissions: [],
  userManagementSupported: false,
  showUserManagementAttestationMessage: false
};
var DEFAULT_REDIRECT_CALLBACK = function DEFAULT_REDIRECT_CALLBACK(appState) {
  document.location.replace(appState.targetUrl.href);
};
export var Auth0Context = React.createContext(defaultAuth0Context);
export var useAuth0 = function useAuth0() {
  return useContext(Auth0Context);
};
export var Auth0Provider = function Auth0Provider(_a) {
  var children = _a.children,
    _a$onRedirectCallback = _a.onRedirectCallback,
    onRedirectCallback = _a$onRedirectCallback === void 0 ? DEFAULT_REDIRECT_CALLBACK : _a$onRedirectCallback,
    initOptions = __rest(_a, ["children", "onRedirectCallback"]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAuthenticated = _useState2[0],
    setIsAuthenticated = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    user = _useState4[0],
    setUser = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    errorGettingPhysician = _useState6[0],
    setErrorGettingPhysician = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    auth0Client = _useState8[0],
    setAuth0 = _useState8[1];
  var _useState9 = useState(true),
    _useState0 = _slicedToArray(_useState9, 2),
    loading = _useState0[0],
    setLoading = _useState0[1];
  var _useState1 = useState(undefined),
    _useState10 = _slicedToArray(_useState1, 2),
    physician = _useState10[0],
    setPhysician = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    institutions = _useState12[0],
    setInstitutions = _useState12[1];
  var _useState13 = useState(undefined),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedInstitution = _useState14[0],
    setSelectedInstitution = _useState14[1];
  var _useState15 = useState(UserState.Loading),
    _useState16 = _slicedToArray(_useState15, 2),
    userState = _useState16[0],
    setUserState = _useState16[1];
  var _useState17 = useState(undefined),
    _useState18 = _slicedToArray(_useState17, 2),
    roles = _useState18[0],
    setRoles = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    emailVerified = _useState20[0],
    setEmailVerified = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isAdmin = _useState22[0],
    setIsAdmin = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    siteRoles = _useState24[0],
    setSiteRoles = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    isVA = _useState26[0],
    setIsVA = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    allPermissions = _useState28[0],
    setAllPermissions = _useState28[1];
  var _useState29 = useState([]),
    _useState30 = _slicedToArray(_useState29, 2),
    allRoles = _useState30[0],
    setAllRoles = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    userManagementSupportedState = _useState32[0],
    setUserManagamentSupported = _useState32[1];
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    showUserManagementAttestationMessageState = _useState34[0],
    setShowUserManagementAttestationMessage = _useState34[1];
  useEffect(function () {
    var getUserState = function getUserState() {
      if (loading) {
        return UserState.Loading;
      }
      if (!isAuthenticated) {
        return UserState.NotLoggedIn;
      } else {
        if (errorGettingPhysician) {
          return UserState.Error;
        }
        if (!physician) {
          return UserState.NeedRegistration;
        }
        if (physician.status == CustomerStatus.WaitingForApproval) {
          return UserState.WaitingForApproval;
        }
        return UserState.Ok;
      }
    };
    setUserState(getUserState());
  }, [loading, isAuthenticated, physician, errorGettingPhysician]);
  var getUserInfo = function getUserInfo(auth0) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var user, token, userObject, claims, subClaim, codes, currentPhysician, newPhysician, faxPhone, _institutions, institutionCodes, parentInstitutionCodes, storedInstitution, institutionId, institutionFound, hasAdminRole;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return auth0.getUser();
            case 2:
              user = _context.sent;
              setUser(user);
              _context.next = 6;
              return auth0.getTokenSilently({
                ignoreCache: false,
                scope: "",
                audience: config.auth0Config.audience
              });
            case 6:
              token = _context.sent;
              sessionStorage.setItem("authToken", token);
              userObject = JSON.parse(JSON.stringify(user));
              sessionStorage.setItem("userEmail", userObject.email);
              setEmailVerified(user.email_verified);
              _context.next = 13;
              return auth0.getIdTokenClaims();
            case 13:
              claims = _context.sent;
              subClaim = claims["sub"];
              setRoles(claims[config.auth0Config.rolesKey]);
              if (!(claims[config.auth0Config.rolesKey] && claims[config.auth0Config.rolesKey].includes("Support"))) {
                _context.next = 22;
                break;
              }
              if (!(GetStoredInstitutionCodes().length === 0)) {
                _context.next = 22;
                break;
              }
              _context.next = 20;
              return getAllHospitalCodes();
            case 20:
              codes = _context.sent;
              sessionStorage.setItem("allInstitutionCodes", codes.join(","));
            case 22:
              _context.prev = 22;
              _context.next = 25;
              return physicians.getCurrent();
            case 25:
              currentPhysician = _context.sent;
              if (!currentPhysician) {
                _context.next = 47;
                break;
              }
              newPhysician = new OrderPhysician(currentPhysician);
              if (currentPhysician.phoneNumbers && currentPhysician.phoneNumbers.length > 0) {
                faxPhone = currentPhysician.phoneNumbers.find(function (phone) {
                  return phone.type && phone.type.toLowerCase() === "fax";
                });
                if (faxPhone) {
                  newPhysician.fax = faxPhone.phoneNumber;
                }
              }
              if (currentPhysician.phoneNumbers && currentPhysician.phoneNumbers.length > 0) {
                newPhysician.phone = currentPhysician.phoneNumbers[0].phoneNumber;
              }
              setPhysician(new OrderPhysician(newPhysician));
              _context.next = 33;
              return physicians.getInstitutions(currentPhysician.id);
            case 33:
              _institutions = _context.sent;
              setInstitutions(_institutions);
              institutionCodes = _institutions.map(function (i) {
                return i.institutionCode;
              });
              parentInstitutionCodes = [];
              if (currentPhysician.customerRoles) {
                parentInstitutionCodes = currentPhysician.customerRoles.map(function (role) {
                  return role.institution.parentCode;
                }).filter(function (code) {
                  return !isNil(code) && code.length > 0;
                });
              }
              sessionStorage.setItem("institutionCodes", institutionCodes.concat(parentInstitutionCodes).join(","));
              storedInstitution = sessionStorage.getItem("institutionId");
              institutionId = storedInstitution ? parseInt(storedInstitution, 10) || 0 : 0;
              if (institutionId > 0) {
                institutionFound = _institutions.find(function (x) {
                  return x.id === institutionId;
                });
              }
              if (subClaim) {
                institutionFound = _institutions.find(function (x) {
                  return x.createdByUser === subClaim;
                });
              }
              if (institutionFound) {
                setSelectedInstitution(institutionFound);
                sessionStorage.setItem("defaultInstitution", institutionFound.id.toString());
              } else {
                sessionStorage.setItem("defaultInstitution", _institutions[0].id.toString());
                setSelectedInstitution(_institutions[0]);
              }
              setErrorGettingPhysician(false);
              _context.next = 48;
              break;
            case 47:
              setErrorGettingPhysician(true);
            case 48:
              setSiteRoles(currentPhysician === null || currentPhysician === void 0 ? void 0 : currentPhysician.customerRoles);
              setUserManagamentSupported((currentPhysician === null || currentPhysician === void 0 ? void 0 : currentPhysician.userManagementSupported) || false);
              setShowUserManagementAttestationMessage((currentPhysician === null || currentPhysician === void 0 ? void 0 : currentPhysician.showUserManagementAttestationMessage) || false);
              hasAdminRole = currentPhysician && currentPhysician.customerRoles && currentPhysician.customerRoles.some(function (role) {
                return role.roles && role.roles.some(function (r) {
                  return r.name === RoleType.SuperUser || r.name === RoleType.UserAdmin;
                });
              });
              setIsAdmin(hasAdminRole);
              _context.next = 63;
              break;
            case 55:
              _context.prev = 55;
              _context.t0 = _context["catch"](22);
              _context.next = 59;
              return postLog(LogLevel.Error, String(_context.t0));
            case 59:
              setPhysician(undefined);
              console.error("Error fetching user data:", _context.t0);
              setIsAdmin(false);
              setIsVA(false);
            case 63:
              _context.prev = 63;
              setLoading(false);
              return _context.finish(63);
            case 66:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[22, 55, 63, 66]]);
    }));
  };
  useEffect(function () {
    var initAuth0 = function initAuth0() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var auth0FromHook, _yield$auth0FromHook$, appState, ex, isAuthenticated;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (window.location.search && window.location.search.toLowerCase().includes("error=") && window.location.search.toLowerCase().includes("verify") && window.location.search.toLowerCase().includes("email")) {
                  setEmailVerified(false);
                  window.location.replace("email-not-verified");
                }
                _context2.next = 3;
                return createAuth0Client(initOptions);
              case 3:
                auth0FromHook = _context2.sent;
                setAuth0(auth0FromHook);
                if (!window.location.search.includes("code=")) {
                  _context2.next = 11;
                  break;
                }
                _context2.next = 8;
                return auth0FromHook.handleRedirectCallback();
              case 8:
                _yield$auth0FromHook$ = _context2.sent;
                appState = _yield$auth0FromHook$.appState;
                onRedirectCallback(appState);
              case 11:
                if (!window.location.search.includes("error=")) {
                  _context2.next = 22;
                  break;
                }
                _context2.prev = 12;
                _context2.next = 15;
                return auth0FromHook.handleRedirectCallback();
              case 15:
                _context2.next = 22;
                break;
              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](12);
                ex = String(_context2.t0);
                _context2.next = 22;
                return postLog(LogLevel.Error, ex);
              case 22:
                _context2.next = 24;
                return auth0FromHook.isAuthenticated();
              case 24:
                isAuthenticated = _context2.sent;
                setIsAuthenticated(isAuthenticated);
                if (!isAuthenticated) {
                  _context2.next = 31;
                  break;
                }
                _context2.next = 29;
                return getUserInfo(auth0FromHook);
              case 29:
                _context2.next = 32;
                break;
              case 31:
                setLoading(false);
              case 32:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[12, 17]]);
      }));
    };
    initAuth0();
  }, []);
  useEffect(function () {
    if (selectedInstitution) {
      sessionStorage.setItem("institutionId", selectedInstitution.id.toString());
      var hasVARole = Boolean(physician && physician.customerRoles && physician.customerRoles.some(function (role) {
        return window.appConfig.vaHospitalCodes.includes(role.institution.code) || window.appConfig.vaHospitalCodes.includes(role.institution.parentCode);
      }) || selectedInstitution && selectedInstitution.institutionCode && (window.appConfig.vaHospitalCodes.includes(selectedInstitution.institutionCode) || window.appConfig.vaHospitalCodes.includes(selectedInstitution.parentInstitutionCode)));
      setIsVA(hasVARole);
    }
  }, [selectedInstitution]);
  var handleRedirectCallback = function handleRedirectCallback() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!auth0Client) {
                _context3.next = 10;
                break;
              }
              _context3.next = 3;
              return auth0Client.handleRedirectCallback();
            case 3:
              _context3.t0 = setIsAuthenticated;
              _context3.next = 6;
              return auth0Client.isAuthenticated();
            case 6:
              _context3.t1 = _context3.sent;
              (0, _context3.t0)(_context3.t1);
              _context3.next = 10;
              return getUserInfo(auth0Client);
            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  };
  var clearCrossDomainMessage = function clearCrossDomainMessage() {
    var doc = document.getElementById("ifr-for-cross-domain");
    if (doc) {
      var contentWindow = doc.contentWindow;
      if (contentWindow) {
        contentWindow.postMessage(undefined, window.appConfig.catalogUrl);
      }
    }
  };
  var handleLogOut = function handleLogOut() {
    if (auth0Client) {
      auth0Client.logout.apply(auth0Client, arguments);
    }
    clearCrossDomainMessage();
    sessionStorage.clear();
  };
  var getAllHospitalCodes = function getAllHospitalCodes() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var codes;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return institutionsApi.getAllInstitutionCodes();
            case 2:
              codes = _context4.sent;
              return _context4.abrupt("return", codes);
            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
  };
  var fetchAllPermissions = useCallback(function () {
    try {
      setAllPermissions(ALL_PERMISSIONS);
    } catch (error) {
      console.error("Error setting permissions:", error);
    }
  }, []);
  var fetchAllRoles = useCallback(function () {
    try {
      setAllRoles(ALL_ROLES);
    } catch (error) {
      console.error("Error setting roles:", error);
    }
  }, []);
  useEffect(function () {
    if (isAuthenticated) {
      fetchAllPermissions();
      fetchAllRoles();
    }
  }, [isAuthenticated]);
  if (auth0Client) {
    return React.createElement(Auth0Context.Provider, {
      value: {
        isAuthenticated: isAuthenticated,
        user: user,
        loading: loading,
        handleRedirectCallback: handleRedirectCallback,
        physician: physician,
        setPhysician: setPhysician,
        institutions: institutions,
        setSelectedInstitution: setSelectedInstitution,
        selectedInstitution: selectedInstitution,
        userState: userState,
        roles: roles,
        getIdTokenClaims: function getIdTokenClaims() {
          return auth0Client.getIdTokenClaims.apply(auth0Client, arguments);
        },
        loginWithRedirect: function loginWithRedirect() {
          return auth0Client.loginWithRedirect.apply(auth0Client, arguments);
        },
        getTokenSilently: function getTokenSilently() {
          return auth0Client.getTokenSilently.apply(auth0Client, arguments);
        },
        logout: function logout() {
          return handleLogOut.apply(void 0, arguments);
        },
        emailVerified: emailVerified,
        isAdmin: isAdmin,
        siteRoles: siteRoles,
        isVA: isVA,
        allRoles: allRoles,
        allPermissions: allPermissions,
        userManagementSupported: userManagementSupportedState,
        showUserManagementAttestationMessage: showUserManagementAttestationMessageState
      }
    }, children);
  }
  return null;
};